/* eslint-disable react-hooks/exhaustive-deps */
import { message } from 'antd';
import { MinusIcon, PlusIcon } from 'lucide-react';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { ValuationComparing } from '../../interfaces/valuation';
import dayjs from 'dayjs';
import { ValuationApi } from '../../apis';
import useSWR from 'swr';
import { formatCurrency } from '../../utils';
import { FINALIZE_PERCENT } from '../../constant/finalize-percent';

// ZVW305122612

const BranchDirectorSideCard = ({ payload: _payload }: { payload: ValuationComparing }) => {
  const payload = _payload as ValuationComparing & { hasVat?: boolean };
  const { mutate } = useSWR('swr.valuation.payload');
  const changing = useRef(false);
  const [calculating, setCalculating] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const changePercent = useCallback(async (step: number) => {
    const newPercent = Number(payload.percentBranchHead ?? 0) + step;
    if (changing.current || newPercent < FINALIZE_PERCENT.ZM.min ||
        newPercent > FINALIZE_PERCENT.BRANCH_MANAGER.max) return;
    changing.current = true;
    setCalculating(true);
    try {
      const priceFinal = await ValuationApi.calculate({
        percentBranchHead: newPercent,
        amount: payload.price,
        percentOdo: payload.percentOdo,
        hasVat: payload.hasVat || false,
      });
      await mutate({ ...payload, percentBranchHead: newPercent, priceFinal }, { revalidate: false });
    } catch (error: any) {
      messageApi.error(error?.message || 'Хувь тооцоолоход алдаа гарлаа');
    } finally {
      changing.current = false;
      setCalculating(false);
    }
  }, [payload, mutate, messageApi]);
  const branchHeadPercentPlus = useCallback(() => changePercent(1), [changePercent]);
  const branchHeadPercentMinus = useCallback(() => changePercent(-1), [changePercent]);

  const renderPercent = useMemo(() => {
    if (
      payload?.status === 'REJECTED' ||
      payload?.status === 'VALUATED' ||
      payload?.status === 'RETURNED' ||
      payload?.status === 'DRAFT'
    ) {
      return (
        <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
          <div className="flex flex-row gap-[10px]">
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload.percentBranchHead}%
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
          <div className="flex flex-row gap-[10px]">
            <button
              type="button"
              aria-label="Зохицуулалтын хувийг бууруулах"
              disabled={calculating || payload.percentBranchHead <= FINALIZE_PERCENT.ZM.min}
              onClick={branchHeadPercentMinus}
              className="
                    w-[30px] h-[30px]
                    rounded-[4px]
                    flex justify-center items-center
                    border border-[#D1D5DC]
                    opacity-100
                    bg-white
                    text-[#6A6A6A]
                    cursor-pointer
                    select-none
                    transition-all
                    hover:bg-[#F3F4F6]
                    active:scale-95"
            >
              <MinusIcon color="#6A6A6A" />
            </button>
            <div className="w-[38px] h-[30px] flex items-center justify-center opacity-100  font-bold text-[16px] leading-[24px] tracking-[-0.48px] text-[#5869FF] rounded">
              {_payload.percentBranchHead}%
            </div>
            <button
              type="button"
              aria-label="Зохицуулалтын хувийг нэмэх"
              disabled={calculating || payload.percentBranchHead >= FINALIZE_PERCENT.BRANCH_MANAGER.max}
              onClick={branchHeadPercentPlus}
              className="
                    w-[30px] h-[30px]
                    rounded-[4px]
                    flex justify-center items-center
                    border border-[#D1D5DC]
                    opacity-100
                    bg-white
                    text-[#6A6A6A]
                    cursor-pointer
                    select-none
                    transition-all
                    hover:bg-[#F3F4F6]
                    active:scale-95"
            >
              <PlusIcon color="#6A6A6A" />
            </button>
          </div>
        </div>

        <div className="h-[10px]" />
        {/* <div>
          <div className="font-manrope text-[14px] leading-[20px] font-[700] tracking-[-0.28px] text-[#5869FF]">
            НӨАТ-тай эсэх
          </div>
          <Checkbox
            checked={payload?.hasVat}
            onChange={async (e) => {
              const res: any = await ValuationApi.calculate({
                percentBranchHead: payload?.percentBranchHead,
                amount: payload?.price,
                percentOdo: payload?.percentOdo,
                hasVat: e.target.checked,
              });

              _setPayload({
                ...payload,
                priceFinal: res,
                hasVat: e.target.checked,
              });

              mutate(
                {
                  ...payload,
                  priceFinal: res,
                  hasVat: e.target.checked,
                },
                {
                  revalidate: false,
                }
              );
            }}
          />
        </div> */}

        <div className=" h-[81px] opacity-100 border-b border-[#F1F5F9] flex flex-1 flex-row pb-[17px] pt-[24px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Зохицуулагдсан үнэлгээ
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {formatCurrency(payload?.price)}
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Эцэлсэн үнэлгээ
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {formatCurrency(payload?.priceFinal)}
            </div>
          </div>
        </div>
      </>
    );
  }, [
    calculating,
    _payload.percentBranchHead,
    branchHeadPercentMinus,
    branchHeadPercentPlus,
    payload?.hasVat,
    payload.percentBranchHead,
    payload?.price,
    payload?.priceFinal,
    payload?.status,
  ]);



  //  await ValuationApi.finalize({
  //         id: payload?.id,
  //         percentOdo: payload.percentOdo,
  //         percentBranchHead: payload.percentBranchHead,
  //         imageUrls: imgs,
  //       });

  console.log('payload.status ===>', payload.status);

  return (
    <div className="top-[443px] rounded-[14px] border border-[#F1F5F9] opacity-100 p-[20px]">
      {contextHolder}
      <div className="font-manrope font-semibold text-[20px] leading-[32px] tracking-[-0.02em]">
        Нэмэлт мэдээлэл
      </div>
      <div className="h-[20px]" />
      <div className="flex flex-col gap-[10px]">
        <div className=" h-[81px] opacity-100 border-b border-[#F1F5F9] flex flex-1 flex-row pb-[17px] pl-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Зээл хүсэгчийн овог, нэр
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload?.customer?.fullName}
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Регистрийн дугаар
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload?.customer?.registerNo}
            </div>
          </div>
        </div>
        {/* item 2 */}

        <div className=" h-[81px] opacity-100 border-b border-[#F1F5F9] flex flex-1 flex-row pb-[17px] pl-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Зээлийн мэргэжилтэн
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload?.valuationUser?.fullName}
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Хүсэлтийн огноо
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {dayjs(payload.createdAt).format('YYYY-MM-DD')}
            </div>
          </div>
        </div>

        {/* item 3 */}

        <div className=" h-[81px] opacity-100 border-b border-[#F1F5F9] flex flex-1 flex-row pb-[17px] pl-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Үнэлгээний дугаар
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload.sequence}
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Километрийн заалтаас хамаарсан зохицуулалт
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload.percentOdo}%
            </div>
          </div>
        </div>

        <div className="w-[454px] h-[81px] opacity-100  flex flex-1 flex-row pb-[17px] pl-[17px] pr-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="flex flex-row justify-between items-center">
              <div className="font-manrope text-[14px] leading-[20px] font-[700] tracking-[-0.28px] text-[#5869FF]">
                Салбарын удирдлагын зохицуулалт
              </div>
            </div>
            <div className="h-[7px]" />
            {renderPercent}
          </div>
        </div>

        {/* end */}
      </div>
    </div>
  );
};

export { BranchDirectorSideCard };
